import { z } from 'zod'

export enum AgentSkillType {
  BRAINSTORM = 'brainstorm',
  DRAFT_CORRESPONDENCE = 'draft_correspondence',
  DRAFT_DEMAND = 'draft_demand',
  DISCOVERY_REQUEST = 'discovery_request',
  RESPOND_TO_DISCOVERY = 'respond_to_discovery',
  CREATE_OUTLINE = 'create_outline',
  SUMMARIZE_BRIEF = 'summarize_brief',
  QUERY_DOCUMENT = 'query_document',
}

export const skillContentSchema = z.object({
  skill: z.union([z.nativeEnum(AgentSkillType), z.string()]), // Convenience of enum for icon construction / won't break if server adds new values
  label: z.string(),
  order: z.number().int(),
  short_description: z.string(),
  long_description: z.string(),
})
export type SkillContent = z.infer<typeof skillContentSchema>

export const skillsContentResponseSchema = z.object({
  skills: z.array(skillContentSchema),
})
export type SkillsContentResponse = z.infer<typeof skillsContentResponseSchema>
